
import React from "react"
import Slider from "react-slick"
import { About } from "./About"
import { Courses } from "./Courses"
import { OurApp } from "./OurApp"
import { ContactUs } from "./ContactUs"
import { useNavigate } from 'react-router-dom'

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"


export const Home = () => {
  return (
    <>
      <HomeContent />
      <Courses />
      <About />
      <br />
      <ContactUs />
      <br />
      <br />
      <OurApp />
      {/* <Blog /> */}
    </>
  )
}
export const HomeContent = () => {

  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/onboard'); // Navigate to the /onboard page
  };
  const carouselImages = [
    'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery3.jpg?alt=media&token=daca2a87-6133-4be0-9646-b762f136cf36',
    'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery10.jpg?alt=media&token=6fa14e7d-feae-445b-ac73-d7107b44c4ce',
    'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery4.jpg?alt=media&token=ff4d09f9-38a0-4f9b-b2e5-ba2b193d9061',
    'https://firebasestorage.googleapis.com/v0/b/pip-college.appspot.com/o/gallery%2Fgallery6.jpg?alt=media&token=79752311-2886-40ea-9f53-a2e5825cdbde'
    // Add more image URLs as needed
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
  };
  return (
    <>
      <section className='relative flex flex-col h-screen overflow-hidden'>
        {/* Background Carousel */}
        <div className='absolute inset-0 z-0'>
          <Slider {...settings}>
            {carouselImages.map((image, index) => (
              <div key={index} className='relative h-full'>
                <img
                  src={image}
                  alt={`carousel-${index}`}
                  className='w-full h-full object-cover' // Adjust opacity for background visibility
                />
              </div>
            ))}
          </Slider>
        </div>

        {/* Page Content */}
        <div className='relative z-10 flex items-center justify-center flex-grow bg-secondary bg-opacity-50'>
          {/* Left Section */}
          <div className='left w-2/3 md:w-full pr-8 text-white'>
            <h1 className='text-5xl leading-tight font-bold mb-4'>
              Welcome to <br /> Pace Setters Training Institute
            </h1>
            <p className='text-lg mt-2'>Where professionals are made.</p>
            <p className='text-sm mt-4'>
              We provide industry-leading, affordable, and quality education. Our programs focus on excellence, integrity, and holistic development to prepare students for their future careers.
            </p>

            {/* Call-to-Action Button */}

            <div className='mt-6'>
              {/* Join Us Button */}
              <button className='bg-secondary hover:bg-primary text-white py-3 px-4 rounded-full font-semibold text-lg transition-all duration-300' onClick={handleClick}>
                Join Us Today
              </button>

              {/* Class Options */}

            </div>
            <h2 className='text-2xl font-semibold mt-6 mb-4'>Our modules</h2>
            <div className='grid grid-cols-3 gap-4'>

              {['Early morning classes', 'Evening classes', 'Late Evening classes', 'Full time classes'].map((classType, index) => (
                <div
                  key={index}
                  className='box rounded-lg shadow-md bg-white cursor-pointer py-4 px-1 text-center transition-transform duration-300 hover:scale-105'
                >
                  <span className='text-sm text-black font-medium'>{classType}</span>
                </div>
              ))}
            </div>

            {/* CTA - Services */}
            {/* <h2 className='text-2xl font-semibold mt-6 mb-4'>We offer</h2> 
            <div className='grid grid-cols-2 gap-4'>
              <button className='bg-white shadow-lg p-4 flex items-center rounded-md hover:shadow-2xl transition'>
                <div className='icon w-10 h-10 rounded-full flex items-center justify-center bg-primary'>
                  <FaUsers size={25} className='text-white' />
                </div>
                <div className='text flex flex-col pl-4'>
                  <span className='text-sm text-black font-medium'>Physical Classes</span>
                  <span className='text-xs text-gray-600'>Structured learning environment</span>
                </div>
              </button>

              <button className='bg-white shadow-lg p-4 flex items-center rounded-md hover:shadow-2xl transition'>
                <div className='icon w-10 h-10 rounded-full flex items-center justify-center bg-primary'>
                  <BsFillLightningChargeFill size={25} className='text-white' />
                </div>
                <div className='text flex flex-col pl-4'>
                  <span className='text-sm text-black font-medium'>Online Classes</span>
                  <span className='text-xs text-gray-600'>Flexible study schedule</span>
                </div>
              </button>
              {/* <button className='bg-white shadow-lg p-4 flex items-center rounded-md hover:shadow-2xl transition'>
                <div className='icon w-10 h-10 rounded-full flex items-center justify-center bg-primary'>
                  <BsFillLightningFill size={25} className='text-white' />
                </div>
                <div className='text flex flex-col pl-4'>
                  <span className='text-sm text-black font-medium'>KASNEB Revision</span>
                  <span className='text-xs text-gray-600'>Summarizing key materials</span>
                </div>
              </button>
              <button className='bg-white shadow-lg p-4 flex items-center rounded-md hover:shadow-2xl transition'>
                <div className='icon w-10 h-10 rounded-full flex items-center justify-center bg-primary'>
                  <FaBook size={25} className='text-white' />
                </div>
                <div className='text flex flex-col pl-4'>
                  <span className='text-sm text-black font-medium'>Revision Notes</span>
                  <span className='text-xs text-gray-600'>Highlight key points</span>
                </div>
              </button> */}
            {/* </div>  */}
          </div>
        </div>
      </section>
    </>
  );
};
